import { render, staticRenderFns } from "./LogoHeader.vue?vue&type=template&id=34b7494e&scoped=true"
import script from "./LogoHeader.vue?vue&type=script&lang=js"
export * from "./LogoHeader.vue?vue&type=script&lang=js"
import style0 from "./LogoHeader.vue?vue&type=style&index=0&id=34b7494e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b7494e",
  null
  
)

export default component.exports